import { TableRowAllowSettings } from "../table/types";
import { ItemTemplateInfo } from "../templates/types";
import { EditRowWithColumns } from "./types";

export const itemTemplateInfoPLACEHOLDER: ItemTemplateInfo = {
  templateName: "",
  templateDisplayAs: "",
  templateId: 0,
  tableName: "",
  order: null,
  detailTemplateId: 0,
  detailLinkColumnAlias: "",
  itemLinkColumnAlias: "",
};

export const editRowPLACEHOLDER: EditRowWithColumns = {
  columns: {},
  row: {
    templateId: 0,
    tableName: "",
    keyValue: "",
    hash: "",
    cells: {},
    allowSettings: {} as TableRowAllowSettings,
  },
};
